export const updateDesign = designValue => ({ type: 'UPDATE_COLOR', designValue });
export const updateLang = langValue => ({ type: 'UPDATE_LANG', langValue });
export const updateInfo = infoValue => ({ type: 'UPDATE_INFO', infoValue });
export const updateRegion = regionValue => ({ type: 'UPDATE_REGION', regionValue });
export const updateStage = stageValue => ({ type: 'UPDATE_STAGE', stageValue });
export const updateStock = stockValue => ({ type: 'UPDATE_STOCK', stockValue });
